__turbopack_context__.v({
  "closedDay": "_2m7X9G_closedDay",
  "container": "_2m7X9G_container",
  "day": "_2m7X9G_day",
  "exceptionDay": "_2m7X9G_exceptionDay",
  "isToday": "_2m7X9G_isToday",
  "openingDayCell": "_2m7X9G_openingDayCell",
  "openingHoursRow": "_2m7X9G_openingHoursRow",
  "openingPeriodCell": "_2m7X9G_openingPeriodCell",
});
